exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.about {\n  -moz-column-count: 2;\n  -moz-column-gap: 20px;\n  -webkit-column-count: 2;\n  -webkit-column-gap: 20px;\n  margin-bottom: 30px;\n}\ndiv.about p {\n  float: left;\n}\n.gallery {\n  width: 100%;\n  max-width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  float: left;\n  padding: 0 15px;\n}\n.gallery .img {\n  max-width: 24%;\n  overflow: hidden;\n  border-radius: 10px 10px 10px 10px;\n  -moz-border-radius: 10px 10px 10px 10px;\n  -webkit-border-radius: 10px 10px 10px 10px;\n  -o-border-radius: 10px 10px 10px 10px;\n  -webkit-appearance: none;\n  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.18);\n}\n.gallery .img img {\n  max-width: 100%;\n  float: left;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/about/about.component.less
// module id = ../../../../../src/app/about/about.component.less
// module chunks = main